import {
  Button,
  Callout,
  Card,
  Classes,
  ControlGroup,
  Dialog,
  // H4,
  Switch,
  Tag,
} from "@blueprintjs/core";
import { DatePicker } from "@blueprintjs/datetime";
import { Timestamp } from "@firebase/firestore-types";
import { Businesses, Users } from "@just-in-types";
import * as format from "date-fns/format";
import jsPDF from "jspdf";
import * as React from "react";
import styled from "react-emotion";
import { firestore } from "../../../firebase";
import firebase from "../../../firebase";
import { isTimestamp, prettyMobile } from "../helpers";
import Coupons from "./Coupons";
import DateOfBirth from "./DateOfBirth";
import NotesDialog from "./NotesDialog";
// import Vehicles from "./Vehicles";
import VehiclesDialog from "./VehiclesDialog";
import domtoimage from 'dom-to-image';
import VoidButton from "./VoidButton";
import html2canvas from "html2canvas";

const getLoyaltyCycle = firebase.functions().httpsCallable("getLoyaltyCycle");

export interface ActiveCheckInProps {
  businessId: null | string;
  // changeMarkForTheft:any;
  checkIn: null | Users.CheckIn;
  currentUser?: null | Users.User;
  previewOptions: Users.ColumnOptions[];
  searchByMobile:any;
  handleAddNewPicksFunc:any;
  siteId: null | string;
  updateMembership: any;
}

type Props = ActiveCheckInProps;

interface VehiclePick {
  docId: string;
  businessId: string;
  combined: string;
  firstName: string;
  make: string;
  mobile: string;
  model: string;
  remainDays?: number;
  siteId: string;
  textSent: boolean;
  timestamp?: null | Timestamp;
  userId: string;
  yearMax: number;
  yearMin: number;
  matches?: any;
}


interface State {
  activateMembershipFeature: boolean;
  coupons: Users.Coupon[];
  isMonthly: boolean;
  isOpen: boolean;
  isOpenInfo: boolean;
  joinDate: undefined | null | Timestamp;
  loadingCoupons: boolean;
  loadingUser: boolean;
  loyaltyCycleText: string;
  markForSellingCar?:boolean;
  markForTheft?:boolean;
  markUserNotes?:boolean;
  membership: Users.Membership;
  memStartDate:null | Date;
  militaryFirstResopnder?:boolean;
  picks: VehiclePick[];
  redeeming: boolean;
  showDatePicker: boolean;
  user: null | Users.User | Users.UserWithAccount;
  userNote: string;
  kioskUiHideDefaultWaiver:boolean;
  kioskUiTextEngEditor:string;
  kioskUiTextSpnEditor:string;
}

interface ImageCardProps {
  height: number;
  src: string;
  width: number;
}

const WaiverTextWrapper = styled("div")`
  border: 2px solid #444;
  border-radius: 12px;
  background:#fff!important;
  padding: 0.5rem;import async from './../../../adminFunctions/cleanCheckIns';
  margin-bottom: 1rem;
`;



const searchBtnStyle = {
  background: "#fff",
  borderRadius: "50%",
  color: "white",
  marginLeft: "5px",
};

const ImageCard = styled(Card)`
  background-image: url(${(props: ImageCardProps) => props.src});
  width: ${(props) => `${props.width}px`};
  height: ${(props) => `${props.height}px`};
  background-size: contain;
  margin: 0 auto 1rem;
`;

const CheckInField: React.SFC<{
  content: string | JSX.Element;
  label: string;
}> = ({ content, label }) => (
  <ControlGroup
    fill={true}
    style={{
      display: "grid",
      gridTemplateColumns: "30% 1fr",
      marginBottom: "0.5rem",
    }}
  >
    <Tag large={true}>{label}</Tag>
    <Tag large={true} minimal={true}>
      {content}
    </Tag>
  </ControlGroup>
);

class ActiveCheckIn extends React.Component<Props, State> {
  public initialCheckIn = {
    coupons: [],
    isMonthly: false,
    isOpen: false,
    isOpenInfo: false,
    loadingCoupons: true,
    loadingUser: false,
    membership: {
      businessId: null,
      end_date: null,
      mobile: null,
      mugshot: null,
      start_date: null,
    },
    redeeming: false,
    user: null,
    userNote: "",
  };

  private unsubscribeUser: null | (() => void) = null;
  private unsubscribeCoupons: null | (() => void) = null;

  constructor(props: Props) {
    super(props);

    const firstState = {
      ...this.initialCheckIn,
      activateMembershipFeature: false,
      joinDate: undefined,
      kioskUiHideDefaultWaiver:false,
      kioskUiTextEngEditor:'',
      kioskUiTextSpnEditor:'', 
      loyaltyCycleText: "...",
      markForSellingCar:props.checkIn?props.checkIn.markForSellingCar:false,
      markForTheft:props.checkIn?props.checkIn.markForTheft:false,
      markUserNotes:props.checkIn?props.checkIn.markUserNotes:false,
      memStartDate:null,
      militaryFirstResopnder:props.checkIn?props.checkIn.militaryFirstResopnder:false,
      picks: [],
      showDatePicker:false,
    };
    this.state = firstState;
    this.handleUserNote = this.handleUserNote.bind(this);
    this.handleAddNewPics = this.handleAddNewPics.bind(this);

    // this.getTest();

  }

  public handleUserNote(){
    this.setState({ markUserNotes : true });
  }

  public handleAddNewPics(res){
    const { checkIn } = this.props;
    this.props.handleAddNewPicksFunc(res);

    if(checkIn && checkIn.mobile !== null && checkIn.businessPath !== null && checkIn.sitePath !== null){
        this.watchPicks(checkIn.mobile, checkIn.businessPath, checkIn.sitePath); 
    }
  }

  public componentDidUpdate({
    businessId: prevBusinessId,
    checkIn: prevCheckIn,
  }: Props) {
    const { businessId, checkIn, siteId } = this.props;


    if (
      (prevCheckIn === null && checkIn) ||
      (prevCheckIn && checkIn && prevCheckIn.checkInId !== checkIn.checkInId)
    ) {
      this.setState({markForSellingCar:checkIn.markForSellingCar,
                      markForTheft:checkIn.markForTheft,
                      markUserNotes:checkIn.markUserNotes,
                      militaryFirstResopnder:checkIn.militaryFirstResopnder 
                    });
      
      this.noteUser(checkIn);
                      
      if (businessId && checkIn.mobile && checkIn.userId !== "opt-out") {
        this.refreshCoupons(businessId, checkIn.mobile, checkIn.userId);
      }
      this.setState({ ...this.initialCheckIn });
      this.subscribeToCoupons(checkIn);
      this.subscribeToUser(checkIn);
      this.membershipUser(checkIn, businessId ? businessId : "");
      this.getLoyaltyCycleText(checkIn);

      if(checkIn.mobile !== null && checkIn.businessPath !== null && checkIn.sitePath !== null){
          this.watchPicks(checkIn.mobile, checkIn.businessPath, checkIn.sitePath); 
      }


      this.getJoinDate(businessId, siteId, checkIn.mobile);
      this.getInteractiveWaiver();
    }

    if (businessId && businessId !== prevBusinessId) {
      this.setMembershipFeatureParamater(businessId);
    }
    

    // if(checkIn){
    //   this.getJoinDate(businessId, siteId, checkIn.mobile);
    // }
  }

  public toggleOpen = () =>
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));

  public toggleOpenInfo = () =>
    this.setState(({ isOpenInfo }) => ({ isOpenInfo: !isOpenInfo }));

  public render() {

    const {
      businessId,
      checkIn,
      currentUser,
      siteId,
    } = this.props;
    let {
      previewOptions,
    } = this.props;
    const {
      activateMembershipFeature,
      loadingCoupons,
      loyaltyCycleText,
      coupons,
      joinDate,
      redeeming,
      isOpen,
      isOpenInfo,
      markForSellingCar,
      markForTheft,
      markUserNotes,
      militaryFirstResopnder,
      membership,
      memStartDate,
      picks,
      showDatePicker,
      userNote,
    } = this.state;

    const prevOption:any= [];
    previewOptions.forEach((ele)=>{
      switch(ele.name){
        case 'mugshot':
          prevOption[0] = ele;
        break;
        case 'signature':
          prevOption[1] = ele;
        break;
        case 'name':
          prevOption[2] = ele;
        break;
        case 'timestamp':
          prevOption[3] = ele;
        break;
        case 'mobile':
          prevOption[4] = ele;
        break;
        case 'coupons':
          prevOption[5] = ele;
        break;
        case 'zip':
          prevOption[6] = ele;
        break;
        case 'email':
          prevOption[7] = ele;
        break;
        case 'covidquestions':
          prevOption[8] = ele;
        break;
        case 'language':
          prevOption[9] = ele;
        break;
        case 'site':
          prevOption[10] = ele;
        break;
        case 'supercard':
          prevOption[11] = ele;
        break;
        case 'dateofbirth':
          prevOption[12] = ele;
        break;
        case 'waiver':
          prevOption[13] = ele;
        break;
        case 'vehicles':
          prevOption[14] = ele;
        break;
      }
    });
    previewOptions = prevOption;

    if (checkIn) {
      const {
        kind,
        mugshot,
        mugshotUrl,
        email,
        language,
        name: { firstname, lastname },
        signature,
        signatureUrl,
        sitePath,
        supercard,
        timestamp,
        // vehicles,
        waiver,
        zip,
      } = checkIn;
      let { mobile } = checkIn;
      
      let mugshotNew = false;
      if(checkIn.name.firstname && checkIn.businessId === "JlxN1z6LzjJWjXcXlNnG"){
        switch(checkIn.name.firstname){
          case 'Brittany ':
            mugshotNew = true;
            break;
          case 'Michael':
            mugshotNew = true;
            break;
          case 'Rob':
            mugshotNew = true;
            break;
          case 'Shaquille':
            mugshotNew = true;
            break;
          case 'Taylor ':
            mugshotNew = true;
            break;
          case '"The Rock"':
            mugshotNew = true;
            break;
          case 'Tiger':
            mugshotNew = true;
            break;
          case 'Tom':
            mugshotNew = true;
            break;
        }
      }


      const currentUserEmail = currentUser ? currentUser.accountData.email : "";
      if (
        mobile &&
        (currentUserEmail === "cs1@picknpullsa.com" ||
          currentUserEmail === "cs2@picknpullsa.com" ||
          currentUserEmail === "garrett@upullits.com") &&
        mobile !== "6028181729"
      ) {
        // hide the full mobile number.
        mobile = this.obscureMobile(mobile);
      }

      let maskedMobile = "";
      if (mobile) {
        if (mobile !== "6028181729") {
          if (
            this.props &&
            this.props.currentUser &&
            this.props.currentUser.accountData.permissions.ismask === true
          ) {
            maskedMobile = this.maskNumber(mobile);
          } else {
            maskedMobile = prettyMobile(mobile);
          }
        }
      }

      let lName = "";
      if (firstname && lastname) {
        if (
          this.props &&
          this.props.currentUser &&
          this.props.currentUser.accountData.permissions.ismask === true
        ) {
          lName = "*******";
        } else {
          lName = lastname;
        }
      }

      // const customerTitle =
      //   firstname && lastname
      //     ? `${firstname} ${lName}`
      //     : mobile
      //       ? mobile === "6028181729"
      //         ? "opted-out"
      //         : maskedMobile
      //       : // : prettyMobile(mobile)
      //         "Unknown";

      return (
        <Card
          id={"print"}
          elevation={2}
          style={{ height: "100%", width: "100%", overflowY: "auto" }}
        >
          {/* <H4>{customerTitle}</H4> */}
          {/* <div id={'print'} style={{ display: 'none' }}>
            <p>hi!</p>
          </div> */}
          <div style={{marginBottom:"40px"}}>
            <div>
              <span className="left_table_info_icon" onClick={this.toggleOpenInfo} style={{ cursor:"pointer" }}>&nbsp;</span>
              <Dialog
                style={{ width:"50%" }}
                isOpen={isOpenInfo}
                onClose={this.closeInfo}
                // title="Information" 
                title={
                  <div>
                      <span className="left_table_info_icon" style={{ float:"left" }}>&nbsp;</span>&nbsp;&nbsp; Information
                  </div>
                } 
              >
                <div className={Classes.DIALOG_BODY}>
                  <p>
                    <b>Download Waiver:</b> First, find the waiver you are searching for with filter by Name, Phone Number, Date, or scrolling through check-ins.  Then, download the waiver with the blue Download Waiver button and look for the .pdf download at the top right or bottom left of your screen. On Google Chrome, the .pdf download is at the bottom left. On Microsoft Edge, the .pdf download is at the top right. 
                  </p>
                  <img src={require("../../../images/image0.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../images/image1.jpg")} style={{ marginBottom:'15px' }} />
                  <p>
                    <b>Add Note:</b> To add a note on a specific customer, find and select their check-in. Next, select the green Add Note button. Type in your note and select Add Note. A green note will pop-up above the buttons on the left table and the note will show up every time this Phone Number checks in. You can undo the note with the gray back button next to Add Note. Also, you will see a green asterisk icon underneath the Phone Number field on the right table every time a customer with an Active Note checks in.
                  </p>
                  <img src={require("../../../images/image2.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../images/image3.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../images/image4.jpg")} style={{ marginBottom:'15px' }} />

                  <p>
                    <b>Theft Prevention:</b> To ban a customer from the yard, then find the customer check-in and select the red Theft Prevention button. This will add a red triangle with an exclamation point underneath the Phone Number field on the right table. If this customer checks in again with the same Phone Number, then the icon will show up underneath their number on the right table. To undo Theft Prevention for a customer, select the silver undo button next to the Theft Prevention button.  Theft Prevention will not prevent customers from checking in with a different number unless that Phone Number is also banned.
                  </p>
                  <img src={require("../../../images/image5.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../images/image6.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Ca$h for Cars:</b> To categorize a customer as a potential source for inventory, then select the customers check-in and the gold Ca$h for Cars button. This will add a gold star underneath this customer in the Phone Number field on the right table. To undo this icon, select the silver undo button next to the Ca$h for Cars button.
                  </p>
                  <img src={require("../../../images/image7.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../images/image8.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Military/First Responder:</b> To recognize a customer as United States military or first responder, then select the check-in and blue Military/First Responder button. This will add the American flag underneath their Phone Number on the right table. Every time this customer checks in, then the American flag icon will display. You can undo this with the silver back button.
                  </p>
                  <img src={require("../../../images/image9.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../images/image10.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Add/Edit Vehicle Picks:</b> : To add a new vehicle pick for a customer, then select the correct check-in and the green Add/Edit Vehicle Picks button. Select Year Range (optional), Make, and Model. The Phone Number auto-populates based on which check-in was selected when the Add a New Pick button was selected. Once the information is complete, then select the green Next button. The next page will show all vehicle picks this customer has active. It will also show whether or not there is any new inventory (added within the last seven days) matches for each vehicle pick. If there is, then you will see a green car with a checkmark next to the pick. You will also see how many days are left for each pick before they expire. You can delete picks for the customer with the red x button on the left and renew picks with the button at the right. Renewing a pick will change the number of days left for that pick to 90 days.
                  </p>
                  <p>
                    To edit your existing picks, select Add/Edit Vehicle Picks and then Edit Picks to access the dashboard for a particular customer. 
                  </p>
                  <img src={require("../../../images/image11.jpg")} style={{ marginBottom:'7px' }} />
                  <br />
                  <img src={require("../../../images/justin_alert.png")} style={{ height:'300px', marginBottom:'15px' }} />


                  <p>
                    <b>Vehicle icon:</b> A vehicle icon will show up underneath the Phone Number field for customers who have active vehicle picks. To see which vehicle picks a customer has active, then select a check-in with a vehicle icon and look in the left column for Vehicle Picks.
                  </p>
                  <img src={require("../../../images/image12.jpg")} style={{ marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../images/image13.jpg")} style={{ marginBottom:'15px' }} />

                  <p>
                    <b>Coupon icon:</b> When customers have active mobile coupons, then you will see a white rectangle with a percent sign underneath Phone Number. To see which coupons this customer has active, select the check-in on the right table and the Coupons data field on the left table will display how many coupons are available for this customer. Select the green Active Coupons button to see which coupons are active.  Coupons are redeemed here or on the mobile phone in the text the customer received.  To see detail on each coupon, select the down arrow on the left side of the coupon.  This will display the description and expiration date.  Once the coupon is redeemed, then it is added to the statistics on the Coupon Summary Report.
                  </p>
                  <img src={require("../../../images/image14.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Customer History:</b> To see the history of a customer checking in, then select the customer in the right table and then select the magnifying glass next to their number on the top of the left table.  This will give you a total check-ins above the right table where it says Check-ins by user and you can find any previous Check-In you are looking for in the right table.
                  </p>
                  <img src={require("../../../images/chk1.png")} style={{ height:'210px', marginBottom:'15px', marginRight:'30px' }} />
                  <img src={require("../../../images/chk2.png")} style={{ height:'210px', marginBottom:'15px' }} />

                  <p>
                    <b>Search by Phone Number:</b> Type number into search field and select silver magnifying glass to search. All check-ins associated with this Phone Number will display in the right table.  A total count is listed next to Check-ins by user. Select one of the check-ins to Download Waiver, add Note, add icons, or Add/Edit Vehicle Picks.
                  </p>
                  <img src={require("../../../images/image15.jpg")} style={{ marginBottom:'15px' }} />

                  <p>
                    <b>Search by Name:</b> Type name into search field and change left filter from Phone Number to Name. Next, select the silver magnifying glass. All check-ins for this Name will show up in the right table. All check-ins associated with this Phone Number will display in the right table.  A total count is listed next to Check-ins by user. Select one of the check-ins to Download Waiver, add Note, add icons, or Add/Edit Vehicle Picks.
                  </p>
                  <img src={require("../../../images/image16.jpg")} style={{ marginBottom:'15px' }} />

                  <p>
                    <b>Search by Date:</b> Select Date with the calendar icon.  Select Month, Year, and Date last. Check-ins will display in right table with newest check-ins first for that day.  So, the last check-in of the day will display first.
                  </p>
                  <img src={require("../../../images/image17.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Show 35, 150, 250, 500, 750, or 1000:</b> Select Show 35 and change to a higher number to display more check-ins in the right table on the first page.  This prevents having to go to the next page if you want to scroll through a lot of check-ins.
                  </p>
                  <img src={require("../../../images/image18.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Go to next page or back to the last page:</b> Use the left and right arrows next to page number to traverse forward to the next page or back to the last page. It might be easier to adjust the Show number instead of changing the page number.
                  </p>
                  <img src={require("../../../images/image19.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Location:</b> The all drop-down allows the ability to select one location.  Once a location is selected, only check-ins from that location will display in the right table.  If displaying all location check-ins, then the Location field will confirm the location. 
                  </p>
                  <img src={require("../../../images/image20.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Change Right Table Defaults:</b> Select the settings icon.  Make changes to the default columns by changing Table Columns or the right column in View Options. The default displays Name, Phone Number, Time, Picture, Date, and Location from left to right. To change the order of how the data is displayed from left to right, then you can use the up and down arrows. Moving data elements up will move them to the left in the right column. To add data fields that are currently not displayed, then you can toggle on and off by selecting the data element.
                  </p>
                  <img src={require("../../../images/image21.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Void Check-In:</b> Select the check-in you want to void. Then, you want to scroll down on the left table and select the red Void Check-In button. A popup will display asking you to confirm you want to void this check-in. Voids cannot be undone.
                  </p>
                  <img src={require("../../../images/image22.jpg")} style={{ marginBottom:'15px' }} />


                  <p>
                    <b>Go To Kiosk:</b> Select location first from all drop-down.  Next, select Go To Kiosk and a new window is created which redirects to the kiosk.
                  </p>
                  <img src={require("../../../images/image23.jpg")} style={{ marginBottom:'15px' }} />

                  <p>
                    <b>Quick Stats:</b> This is an excellent resource for getting a quick snapshot of statistics.  On the Check-Ins page, you can select Daily, Weekly, or Monthly from the drop-down.  Daily will show statistics for the current day. Weekly shows statistics over the last 7 days. Monthly shows statistics over the last 30 days. Check-Ins is the total number of Check-Ins that were completed within the time period selected.  Kiosk Opt-Outs is the total number of times customers checked in, but opted-out of providing their phone number during the same timeframe.  Re-Checks are the total number of times customers checked in for the second or more times during the same day.  Voids are the total number of times Check-Ins were deleted or voided out of the system for the same timeframe.
                  </p>
                  <img src={require("../../../images/image24.png")} style={{ marginBottom:'15px' }} />

                </div>
              </Dialog>      
            </div>
            <br />
            <br />
            <div id="name_phone_block" style={{ marginBottom:"20px" }}>
              <span style={{ float:'left', fontSize:'22px' }}>    
                {previewOptions[2].enabled?(
                    firstname &&
                    lastname && (
                      (firstname.length + lastname.length) < 16 ? (
                        `${firstname} ${lName}`
                      ):(`${firstname} ...`)
                      
                    )              
                  ):("")
                }
              </span>
              <span style={{ float:'right', fontSize:'22px' }}>
                {previewOptions[4].enabled?(
                  mobile?
                  mobile === "6028181729"?
                    "opted-out":maskedMobile
                  :('')
                ):('')
                }
                <Button
                  style={searchBtnStyle}
                  onClick={() => {
                    this.handleMobileSearch(mobile);
                  }}
                  icon="search"
                />  

              </span>
            </div>
            {joinDate && timestamp && joinDate.isEqual(timestamp)?(
              <div>
                <br />
                <div style={{ float:'right', fontSize:'22px', marginRight:'10%'}}>
                  <img src={require("../../../images/new_cust.png")} height={35} width={45} />
                </div>
                <br />
              </div>
            ):(
              ""
            )}
            <br />
            <br />
            <div id="note-style1" style={{color:"#000"}}>
              {markUserNotes && userNote && (
                <Callout
                  title="Important Note"
                  intent="success"
                  style={{ marginBottom: "0.5rem" }}
                >
                  {userNote}
                </Callout>
              )}
            </div>
            <div className={'left_side_txt_btn'}>
              <span id="download-style">
                <Button
                  onClick={this.downloadPDF}
                  style={{ marginBottom: "0.5rem" }}
                  id="download-waiver-btn"
                >
                  Download Waiver
                </Button>
              </span>
              &nbsp;
              {activateMembershipFeature ? (
                <>
                  <span id="promem-btn-style">
                    <Button
                      onClick={this.toggleOpen}
                      style={{ marginBottom: "0.5rem" }}
                    >
                      Pro membership
                    </Button>
                  </span>
                  <Dialog
                    isOpen={isOpen}
                    onClose={this.close}
                    title="Pro Membership"
                  >
                    <div className={Classes.DIALOG_BODY}>
                      {membership.mugshot ? (
                        <ImageCard
                          elevation={2}
                          src={membership.mugshot}
                          width={100}
                          height={100}
                        />
                      ) : (
                        mugshot && (
                          <ImageCard
                            elevation={2}
                            src={mugshot}
                            width={100}
                            height={100}
                          />
                        )
                      )}

                      <ControlGroup
                        fill={true}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "30% 1fr",
                          marginBottom: "0.5rem",
                        }}
                      >
                        <Tag large={true}>Mobile</Tag>
                        <Tag interactive={true} large={true} minimal={true}>
                          {membership.mobile ? membership.mobile : mobile}
                        </Tag>
                      </ControlGroup>
                      <ControlGroup
                        fill={true}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "30% 1fr",
                          marginBottom: "0.5rem",
                        }}
                      >
                        <Tag large={true}>Start Date</Tag>
                        <Tag interactive={true} large={true} minimal={true} onClick={() => this.selectMemshiStartDate(showDatePicker,membership)}>
                          {membership.start_date
                            ? (memStartDate?format(
                              isTimestamp(memStartDate) ? memStartDate.toDate() : memStartDate,
                              "M/D/YY"
                            ):format(membership.start_date, "M/D/YY"))
                            : (memStartDate?format(
                              isTimestamp(memStartDate) ? memStartDate.toDate() : memStartDate,
                              "M/D/YY"
                            ):"Not a Member")}
                        </Tag>
                        <span id="memdatepicker">
                        {showDatePicker ? (
                            <DatePicker
                              className={"datepicker"}
                              onChange={this.handleDateChange}
                            />
                          ) : (
                            ""
                        )}
                        </span>
                      </ControlGroup>
                      <ControlGroup
                        fill={true}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "30% 1fr",
                          marginBottom: "0.5rem",
                        }}
                      >
                        <Tag large={true}>End Date</Tag>
                        <Tag interactive={true} large={true} minimal={true}>
                          {membership.end_date
                            ? format(membership.end_date, "M/D/YY")
                            : "Not a Member"}
                        </Tag>
                      </ControlGroup>

                      {membership.end_date ? (
                        membership.end_date < new Date().valueOf() ? (
                          ""
                        ) : (
                          <div>
                            <ControlGroup>
                              <span
                                style={{ paddingRight: "5px", fontSize: "12pt" }}
                              >
                                Yearly
                              </span>
                              <Switch
                                checked={this.state.isMonthly}
                                large={true}
                                onChange={this.handleMonthlyChange}
                              />
                              <span style={{ fontSize: "12pt" }}>Monthly </span>
                            </ControlGroup>
                            <Button
                              intent="success"
                              style={{ marginBottom: "0.5rem" }}
                              onClick={this.addMembership}
                            >
                              Renew Membership
                            </Button>
                          </div>
                        )
                      ) : (
                        <div>
                          <ControlGroup>
                            <span style={{ paddingRight: "5px", fontSize: "12pt" }}>
                              Yearly
                            </span>
                            <Switch
                              checked={this.state.isMonthly}
                              large={true}
                              onChange={this.handleMonthlyChange}
                            />
                            <span style={{ fontSize: "12pt" }}>Monthly </span>
                          </ControlGroup>
                          <Button
                            intent="success"
                            style={{ marginBottom: "0.5rem" }}
                            onClick={this.addMembership}
                          >
                            Add Membership
                          </Button>
                        </div>
                      )}
                    </div>
                  </Dialog>
                </>
              ) : (
                ""
              )}
              &nbsp;
              
              <span id="note-style">
                <NotesDialog checkIn={checkIn} handleUserNote={this.handleUserNote} />
              </span>
            </div>
            <div className={'left_side_txt_btn'}>
              <div style={{display:"inline-flex"}} id="left_side_theft_n_cash_btn_block">
                <span id="markfortheftswitch" style={{paddingRight:"10px"}} className="right_side_button">
                  <Button disabled={(this.props.checkIn && this.props.checkIn.userId === 'opt-out' )? true:false} style={{background:markForTheft?"#9B9B9B":"#EA0000",marginBottom:"10px",color:"#fff"}} onClick={() => this.markForTheft(checkIn)}>
                    Theft Prevention
                  </Button>
                  {markForTheft?(
                    <span className="left-side-undo-icon">
                      <Button disabled={(this.props.checkIn && this.props.checkIn.userId === 'opt-out' )? true:false} icon="undo" style={{background:"#9B9B9B",marginBottom:"10px",marginLeft:"10px"}} onClick={() => this.undoMarkForTheft(checkIn)} />
                    </span>
                    ):("")
                  }&nbsp;
                </span>

                <span id="markforsellingcarswitch" style={{paddingRight:"10px"}} className="right_side_button">
                  <Button disabled={(this.props.checkIn && this.props.checkIn.userId === 'opt-out' )? true:false} style={{background:markForSellingCar?"#9B9B9B":"#ac931b",marginBottom:"10px",color:"#fff"}} onClick={() => this.markForSellingCar(checkIn)}>
                    Ca$h for Cars
                  </Button>
                  {markForSellingCar?(
                    <span className="left-side-undo-icon">
                      <Button disabled={(this.props.checkIn && this.props.checkIn.userId === 'opt-out' )? true:false} icon="undo" style={{background:"#9B9B9B",marginBottom:"10px",marginLeft:"10px"}} onClick={() => this.undoMarkForSellingCar(checkIn)} />
                    </span>
                    ):("")
                  }
                  </span>
              </div>
            </div>
            <div className={'left_side_txt_btn'}>
              <div style={{display:"inline-flex"}}>
                <span id="militaryFirstResopnderSwitch" className="right_side_button" style={{paddingRight:"10px"}} >
                  <Button disabled={(this.props.checkIn && this.props.checkIn.userId === 'opt-out' )? true:false} style={{background:militaryFirstResopnder?"#9B9B9B":"#00264E",marginBottom:"10px",color:"#fff"}} onClick={() => this.militaryFirstResopnder(checkIn)}>
                    Military/First Responder
                  </Button>

                  {militaryFirstResopnder?(
                    <span className="left-side-undo-icon">
                      <Button disabled={(this.props.checkIn && this.props.checkIn.userId === 'opt-out' )? true:false} icon="undo" style={{background:"#9B9B9B",marginBottom:"10px",marginLeft:"10px"}} onClick={() => this.undoMilitaryFirstResopnder(checkIn)} />
                    </span>
                  ):
                  ("")
                  }
                </span>
                <span id="note-style">
                  <span id="addaNewPickSwitch">
                    <VehiclesDialog checkIn={checkIn} handleAddNewPics={this.handleAddNewPics} />
                  </span>
                </span>
              </div>
            </div>
          </div>

          {/* {previewOptions
            .filter(({ enabled }) => enabled)
            .map(({ name }, index) => {
              switch (name) {
                case "coupons":
                  return (
                    <Coupons
                      activeBusinessId={businessId}
                      activeSiteId={siteId}
                      coupons={coupons}
                      key={index}
                      loading={loadingCoupons}
                      loyaltyCycleText={loyaltyCycleText}
                      redeemCoupon={this.redeemCoupon}
                      redeeming={redeeming}
                    />
                  );
                case "dateofbirth":
                  return <DateOfBirth checkIn={checkIn} key={index} />;
                case "email":
                  return (
                    email && (
                      <CheckInField
                        content={email}
                        label={"Email"}
                        key={index}
                      />
                    )
                  );
                case "language":
                  return (
                    <CheckInField
                      content={language === "eng" ? "English" : "Spanish"}
                      label="Language"
                      key={index}
                    />
                  );
                case "mobile":
                  return (
                    mobile && (
                      <CheckInField
                        content={maskedMobile}
                        // content={prettyMobile(mobile)}
                        label="Phone Number"
                        key={index}
                      />
                    )
                  );
                case "mugshot":
                  return mugshot ? (
                    <ImageCard
                      key={index}
                      elevation={2}
                      src={mugshot}
                      width={250}
                      height={250}
                    />
                  ) : (
                    <ImageCard
                      key={index}
                      elevation={2}
                      src={mugshotUrl ? mugshotUrl : ""}
                      width={250}
                      height={250}
                    />
                  );
                case "name":
                  return (
                    firstname &&
                    lastname && (
                      <CheckInField
                        content={`${firstname} ${lName}`}
                        label="Name"
                        key={index}
                      />
                    )
                  );
                case "signature":
                  return signature ? (
                    <ImageCard
                      elevation={2}
                      key={index}
                      src={signature}
                      width={250}
                      height={100}
                      style={{marginBottom:"50px"}}
                    />
                  ) : (
                    <ImageCard
                      elevation={2}
                      key={index}
                      src={signatureUrl ? signatureUrl : ""}
                      width={250}
                      height={100}
                      style={{marginBottom:"50px"}}
                    />
                  );
                case "site":
                  return (
                    sitePath && (
                      <CheckInField
                        content={sitePath}
                        label="Location"
                        key={index}
                      />
                    )
                  );
                case "supercard":
                  return (
                    supercard && (
                      <CheckInField
                        content={supercard.toString()}
                        label="Supercard"
                        key={index}
                      />
                    )
                  );
                case "timestamp":
                  return (
                    <CheckInField
                      content={format(timestamp.toDate(), "M/D/YY h:mma")}
                      label="Timestamp"
                      key={index}
                    />
                  );
                // case "vehicles":
                //   return (
                //     vehicles.map(({ make, model, yearMax, yearMin }, idx) => (
                //       (
                //         <CheckInField
                //         content={`${yearMin}-${yearMax} | ${make} | ${model}`}
                //         label="Vehicle Picks"
                //         key={idx}
                //       />
                //       )
                //     )));
                case "zip":
                  return (
                    zip && (
                      <CheckInField content={zip} label="Zip" key={index} />
                    )
                  );
                default:
                  return;
              }
            })}{" "}
          <div>
            {kind && kind === "recheck" ? (
              <CheckInField content={`Yes`} label="Re-Check" />
            ) : (
              <CheckInField
                content={
                  kind && kind === "sister-yard-recheck" ? "Sister Yard" : "No"
                }
                label="Re-Check"
              />
            )}
          </div>
          <div>
            {previewOptions[14].enabled?(
              
              vehicles.map(({ make, model, yearMax, yearMin }, idx) => (
                (
                  <span id="left_table_vehicle_pick">
                  <CheckInField
                  content={`${yearMin}-${yearMax} | ${make} | ${model}`}
                  label="Vehicle Picks"
                  key={idx}
                />
                </span>
                )

            ))):("")
            }
          </div> */}
          
{/* {here edit start}  */}
          <div>
            {previewOptions[0].enabled?
            mugshotNew && checkIn.name.firstname === 'Brittany '?
            <ImageCard
              elevation={2}
              src={require("../../../images/Brittany_Spears.jpg")} 
              width={250}
              height={250}
              style={{ backgroundRepeat:"no-repeat", backgroundSize: "cover" }}
            />
            :('')
            :('')
            }
          </div>

          <div>
            {previewOptions[0].enabled?
            mugshotNew && checkIn.name.firstname === 'Michael'?
            <ImageCard
              elevation={2}
              src={require("../../../images/Michael_Jordan.jpg")} 
              width={250}
              height={250}
              style={{ backgroundRepeat:"no-repeat", backgroundSize: "cover" }}
            />
            :('')
            :('')
            }
          </div>

          <div>
            {previewOptions[0].enabled?
            mugshotNew && checkIn.name.firstname === 'Rob'?
            <ImageCard
              elevation={2}
              src={require("../../../images/Rob_Gronkowski.jpg")} 
              width={250}
              height={250}
              style={{ backgroundRepeat:"no-repeat", backgroundSize: "cover" }}
            />
            :('')
            :('')
            }
          </div>

          <div>
            {previewOptions[0].enabled?
            mugshotNew && checkIn.name.firstname === 'Shaquille'?
            <ImageCard
              elevation={2}
              src={require("../../../images/Shaq.jpg")} 
              width={250}
              height={250}
              style={{ backgroundRepeat:"no-repeat", backgroundSize: "cover" }}
            />
            :('')
            :('')
            }
          </div>

          <div>
            {previewOptions[0].enabled?
            mugshotNew && checkIn.name.firstname === 'Taylor '?
            <ImageCard
              elevation={2}
              src={require("../../../images/Taylor_Swift.jpg")} 
              width={250}
              height={250}
              style={{ backgroundRepeat:"no-repeat", backgroundSize: "cover" }}
            />
            :('')
            :('')
            }
          </div>

          <div>
            {previewOptions[0].enabled?
            mugshotNew && checkIn.name.firstname === '"The Rock"'?
            <ImageCard
              elevation={2}
              src={require("../../../images/The_Rock_Johnson.jpg")} 
              width={250}
              height={250}
              style={{ backgroundRepeat:"no-repeat", backgroundSize: "cover" }}
            />
            :('')
            :('')
            }
          </div>

          <div>
            {previewOptions[0].enabled?
            mugshotNew && checkIn.name.firstname === 'Tiger'?
            <ImageCard
              elevation={2}
              src={require("../../../images/Tiger_Woods.jpg")} 
              width={250}
              height={250}
              style={{ backgroundRepeat:"no-repeat", backgroundSize: "cover" }}
            />
            :('')
            :('')
            }
          </div>

          <div>
            {previewOptions[0].enabled?
            mugshotNew && checkIn.name.firstname === 'Tom'?
            <ImageCard
              elevation={2}
              src={require("../../../images/Tom_Brady.jpg")} 
              width={250}
              height={250}
              style={{ backgroundRepeat:"no-repeat", backgroundSize: "cover" }}
            />
            :('')
            :('')
            }
          </div>

          <div>
            {previewOptions[0].enabled?(
                  !mugshotNew?
                  mugshot ? (
                    <ImageCard
                      elevation={2}
                      src={mugshot} 
                      width={250}
                      height={250}
                    />
                  ) : (
                    <ImageCard
                      elevation={2}
                      src={mugshotUrl ? mugshotUrl : ""}
                      width={250}
                      height={250}
                    />
                  ):("")              
              ):("")
            }
          </div>

          <div>
            {previewOptions[1].enabled?(
                  signature ? (
                    <ImageCard
                      elevation={2}
                      src={signature}
                      width={250}
                      height={100}
                      style={{marginBottom:"50px", backgroundRepeat:"no-repeat", backgroundSize: "contain"}}
                    />
                  ) : (
                    <ImageCard
                      elevation={2}
                      src={signatureUrl ? signatureUrl : ""}
                      width={250}
                      height={100}
                      style={{marginBottom:"50px", backgroundRepeat:"no-repeat", backgroundSize: "contain" }}
                    />
                  )              
              ):("")
            }
          </div>

          {/* <div>
            {previewOptions[2].enabled?(
                firstname &&
                lastname && (
                  <CheckInField
                    content={`${firstname} ${lName}`}
                    label="Name"
                  />
                )              
              ):("")
            }
          </div>
 */}

          {
            joinDate?(
              <div>
                <CheckInField
                  content={format(joinDate.toDate(), "M/D/YY h:mma")}
                  label="Date Joined"
                />
              </div>              
            ):
            (
              ""
            )
          }

          <div>
            {previewOptions[5].enabled?(
                <Coupons
                  activeBusinessId={businessId}
                  activeSiteId={siteId}
                  coupons={coupons}
                  displayCoupon = {true}
                  loading={loadingCoupons}
                  loyaltyCycleText={loyaltyCycleText}
                  redeemCoupon={this.redeemCoupon}
                  redeeming={redeeming}
                />
              ):("")
            }
          </div>

          <div>
            {previewOptions[14].enabled?(
              
              picks.map(({ make, model, yearMax, yearMin }, idx) => (
                (
                  <span id="left_table_vehicle_pick">
                  <CheckInField
                  content={`${yearMin}-${yearMax} | ${make} | ${model}`}
                  label="Vehicle Picks"
                  key={idx}
                />
                </span>
                )

            ))):("")
            }
          </div>

          <div>
            {previewOptions[9].enabled?(
                <CheckInField
                  content={language === "eng" ? "English" : "Spanish"}
                  label="Language"
                />
              ):("")
            }
          </div>

          <div>
            {previewOptions[5].enabled?(
                <Coupons
                  activeBusinessId={businessId}
                  activeSiteId={siteId}
                  coupons={coupons}
                  displayCoupon = {false}
                  loading={loadingCoupons}
                  loyaltyCycleText={loyaltyCycleText}
                  redeemCoupon={this.redeemCoupon}
                  redeeming={redeeming}
                />
              ):("")
            }
          </div>

          <div>
            {kind && kind === "recheck" ? (
              <CheckInField content={`Yes`} label="Re-Check" />
            ) : (
              <CheckInField
                content={
                  kind && kind === "sister-yard-recheck" ? "Sister Yard" : "No"
                }
                label="Re-Check"
              />
            )}
          </div>
{/* 
          <div>
            {previewOptions[4].enabled?(
                    mobile && (
                      <CheckInField
                        content={maskedMobile}
                        // content={prettyMobile(mobile)}
                        label="Phone Number"
                      />
                    )
              ):("")
            }
          </div>
 */}
          <div>
            {previewOptions[3].enabled?(
              <CheckInField
                content={format(timestamp.toDate(), "M/D/YY h:mma")}
                label="Timestamp"
              />
              ):("")
            }
          </div>

          <div>
            {previewOptions[12].enabled?(
                <DateOfBirth checkIn={checkIn} />
              ):("")
            }
          </div>

          <div>
            {previewOptions[6].enabled?(
                zip && (
                  <CheckInField content={zip} label="Zip" />
                )
              ):("")
            }
          </div>

          <div>
            {previewOptions[7].enabled?(
                email && (
                  <CheckInField
                    content={email}
                    label={"Email"}
                  />
                )
              ):("")
            }
          </div>

          <div>
            {previewOptions[10].enabled?(
                sitePath && (
                  <CheckInField
                    content={sitePath}
                    label="Location"
                  />
                )
              ):("")
            }
          </div>

          <div>
            {previewOptions[11].enabled?(
                supercard && (
                  <CheckInField
                    content={supercard.toString()}
                    label="Supercard"
                  />
                )
              ):("")
            }
          </div>


{/* {here edit end}  */}


          <div>
            {waiver ? (
              <div>
                <ControlGroup
                  fill={true}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "30%",
                    marginBottom: "0.5rem",
                  }}
                >
                    <Tag large={true}> Digital Waiver </Tag>
                </ControlGroup>    
                <ControlGroup
                  fill={true}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "100%",
                    marginBottom: "0.5rem",
                  }}
                >
                   <WaiverTextWrapper  id="WaiverTextWrapper">
                <div dangerouslySetInnerHTML={{ __html: waiver.split('<p').join('<span') }} />
              </WaiverTextWrapper>
                </ControlGroup>    
              </div>
            ) : (
              ""
            )}
          </div>
          {currentUser && currentUser.accountData && currentUser.accountData.permissions.isVoidCheckIn?
            (<div className={"left_side_top_margin left_side_void_btn"}>  
            <VoidButton currentUser={currentUser} checkInId={checkIn.checkInId} />
          </div>):
          ('')
          }
          
      

        </Card>
      );
    } else {
      return (
        <Card className="active_chkin_main_block">
          Select a check-in on the right to see customer details.
        </Card>
      );
    }
  }


  private handleMobileSearch = (mobile) => {
    this.props.searchByMobile(mobile);
  }

  private undoMarkForTheft = async (checkIn) =>{
    const markForTheft = false;

    this.setState({markForTheft});

    try {
      await firestore
        .collection("checkIns")
        .doc(checkIn.checkInId)
        .update({
          'markForTheft': markForTheft
        });
    } catch (error) {
      throw new Error(error);
    }
  }
  private undoMilitaryFirstResopnder = async (checkIn) =>{
    const militaryFirstResopnder = false;

    this.setState({militaryFirstResopnder});

    try {
      await firestore
        .collection("checkIns")
        .doc(checkIn.checkInId)
        .update({
          'militaryFirstResopnder': militaryFirstResopnder
        });
    } catch (error) {
      throw new Error(error);
    }
  }
  private undoMarkForSellingCar = async (checkIn) =>{
    const markForSellingCar = false;

    this.setState({markForSellingCar});

    try {
      await firestore
        .collection("checkIns")
        .doc(checkIn.checkInId)
        .update({
          'markForSellingCar': markForSellingCar
        });
    } catch (error) {
      throw new Error(error);
    }
  }
  private markForTheft = async (checkIn) =>{
    const markForTheft = true;
    this.setState({markForTheft});
  
    try {
      await firestore
        .collection("checkIns")
        .doc(checkIn.checkInId)
        .update({
          'markForTheft': markForTheft
        });
    } catch (error) {
      throw new Error(error);
    }

  }
  
  private militaryFirstResopnder = async (checkIn) =>{
    const militaryFirstResopnder = true;
    this.setState({ militaryFirstResopnder });
  
    try {
      await firestore
        .collection("checkIns")
        .doc(checkIn.checkInId)
        .update({
          'militaryFirstResopnder': militaryFirstResopnder
        });
    } catch (error) {
      throw new Error(error);
    }

  }
  
  private markForSellingCar = async (checkIn) =>{
    const markForSellingCar = true;
    this.setState({markForSellingCar});
    try {
      await firestore
        .collection("checkIns")
        .doc(checkIn.checkInId)
        .update({
          'markForSellingCar': markForSellingCar
        });
    } catch (error) {
      throw new Error(error);
    }

  }
  
  private maskNumber = (num: any) => {
    const x = num.toString().match(/(\d{3})(\d{3})(\d{4})/);
    return "(" + x[1] + ")" + " *** " + x[3];
  };

  private close = () => this.setState({ isOpen: false });
  private closeInfo = () => this.setState({ isOpenInfo: false });

  private obscureMobile = (value: string) => {
    const valueArr = value.split("");
    valueArr[4] = "*";
    valueArr[5] = "*";
    valueArr[6] = "*";
    return valueArr.join("");
  };

  private handleMonthlyChange = () =>
    this.setState(({ isMonthly }) => ({ isMonthly: !isMonthly }));

  private addMembership = async () => {
    const { checkIn } = this.props;
    const { isMonthly } = this.state;
    const { memStartDate } = this.state;


    let endDate: any;
    let newmembership:any;

    if (checkIn) {
      const query = await firestore
        .collection(`membership`)
        .where("mobile", "==", checkIn.mobile)
        .limit(1)
        .get();

      if(memStartDate){
        const tempStartDate = new Date(memStartDate);
        
        if (isMonthly) {
          endDate = new Date(
            tempStartDate.setMonth(tempStartDate.getMonth() + 1)
          ).valueOf();
        } else {
          endDate = new Date(
            tempStartDate.setFullYear(tempStartDate.getFullYear() + 1)
          ).valueOf();
        }
        newmembership = {
          businessId: checkIn.businessId,
          end_date: endDate,
          mobile: checkIn.mobile,
          mugshot: checkIn.mugshot,
          start_date: memStartDate.valueOf(),
        };
      }else{
        if (isMonthly) {
          endDate = new Date(
            new Date().setMonth(new Date().getMonth() + 1)
          ).valueOf();
        } else {
          endDate = new Date(
            new Date().setFullYear(new Date().getFullYear() + 1)
          ).valueOf();
        }

        newmembership = {
          businessId: checkIn.businessId,
          end_date: endDate,
          mobile: checkIn.mobile,
          mugshot: checkIn.mugshot,
          start_date: new Date().valueOf(),
        };        

      }
  
    
      if (query.size > 0) {
        query.docs[0].ref.set(newmembership);
      } else {
        await firestore.collection(`membership`).add(newmembership);
      }

      this.setState({ showDatePicker:false, memStartDate:newmembership.start_date,membership:newmembership });

      this.props.updateMembership();
    }

    this.setState({ isOpen: false });
  };
  
  private callRefreshCoupons = async (
    businessId: string,
    guid: string,
    mobile: string,
    userId: string
  ) => {
    const url =
      "https://us-central1-just-in-north.cloudfunctions.net/refreshCustomerCoupons";

    try {
      console.log("querying coupons....");
      const response = await fetch(url, {
        body: JSON.stringify({
          businessId,
          guid,
          mobile,
          userId,
        }),
        method: "post",
      });
      const text = await response.text();
      console.log(text);
    } catch (err) {
      console.log(err);
    }
  };


  private getInteractiveWaiver = async()=>{
    const { checkIn } = this.props;
    if(checkIn){
      firestore
        .collection("businesses")
        .doc(checkIn.businessId)
        .collection("sites")
        .where("siteId", "==", checkIn.siteId)
        .get()
        .then((siteSnap) => {

          if(siteSnap && siteSnap.docs[0]){

            const data = siteSnap.docs[0].data();
            const kioskUiHideDefaultWaiver = data.kioskUiHideDefaultWaiver?data.kioskUiHideDefaultWaiver:false;
            const kioskUiTextEngEditor = data.kioskUiTextEngEditor?data.kioskUiTextEngEditor:'';
            const kioskUiTextSpnEditor = data.kioskUiTextSpnEditor?data.kioskUiTextSpnEditor:'';
  
            this.setState({ kioskUiHideDefaultWaiver, kioskUiTextEngEditor, kioskUiTextSpnEditor });
          }

        });
  
    }

  }

  private refreshCoupons = async (
    businessId: string,
    mobile: string,
    userId: string,
    siteId?: string
  ) => {
    // refresh coupons
    console.log("starting coupon refresh....");
    const query = await firestore
      .collection("businesses")
      .where("businessId", "==", businessId)
      .get();
    const businessGuid = query.docs[0].data().guid;
    this.callRefreshCoupons(businessId, businessGuid, mobile, userId);

    // now do this for every site
    const sitesQuery = await query.docs[0].ref.collection("sites").get();
    sitesQuery.forEach((doc) => {
      const siteGuid = doc.data().guid;
      if (siteGuid) {
        this.callRefreshCoupons(businessId, siteGuid, mobile, userId);
      }
    });
  };

  private urlToImg = (url: string | null) => {
    if (!url) {
      return;
    }
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
      img.src = url;
      img.onerror = (err) => reject(err);
      img.onload = () => {
        resolve(img);
      };
    });
  };

  private downloadPDF = async () => {
    const { checkIn } = this.props;
    (window as any).html2canvas = html2canvas;

    const input = document.querySelector<HTMLElement>("#WaiverTextWrapper")!; 

    const downloadBtn = document.querySelector<HTMLElement>("#download-waiver-btn")!;
    downloadBtn.innerText = '.pdf';
    downloadBtn.style.background = '#9b9b9b';

    let heightofPdf: any = 0;

    if (checkIn ) {

      if(input!==null){
 heightofPdf = input.clientHeight;
      }else{
 heightofPdf =0;
      }

      // const doc = new jsPDF("p", "pt", "a4");
      const doc =   jsPDF({
        orientation: 'p', // landscape
        unit: 'pt', // points, pixels won't work properly
        format: [600,heightofPdf+500] // set needed dimensions for any element
  });

      doc.setFontSize(11);
      doc.text(
        "Mobile: " + checkIn.mobile !== "opted-out"
          ? prettyMobile(checkIn.mobile ? checkIn.mobile : "")
          : "opted out",
        50,
        30
      );
      doc.text(format(checkIn.timestamp.toDate(), "M/D/YY h:mma"), 410, 30);

      if (checkIn.mugshot) {
        doc.addImage(checkIn.mugshot, 50, 60, 200, 200);
      } else {
        let mugshot: any = null;
        mugshot = await this.urlToImg(checkIn.mugshotUrl);
        if(checkIn.mugshotUrl !== null && typeof mugshot !== 'undefined'){
          doc.addImage(mugshot, 50, 60, 200, 200);
        }
      }

      if (checkIn.signature) {
        doc.addImage(checkIn.signature, 300, 160, 250, 100);
      } else {
        let signature: any = null;
        signature = await this.urlToImg(checkIn.signatureUrl);
        if(checkIn.signatureUrl !== null && typeof signature !== 'undefined'){
          doc.addImage(signature, 300, 160, 250, 100);
        }
      }

      let str = checkIn.sitePath;
      if (checkIn.businessPath) {
        if (checkIn.name.displayName) {
          str =
            checkIn.name.displayName +
            " at " +
            checkIn.businessPath +
            " " +
            checkIn.sitePath;
        } else {
          str = checkIn.businessPath + " " + checkIn.sitePath;
        }
      }
      doc.text(50, 300, str);
      domtoimage.toPng(input, { cacheBust: true })
      .then( async (dataUrl) =>  {
        let image: any = null;
        image =  await this.urlToImg(dataUrl);
      
        doc.addImage(image, 80, 320, image.width, image.height);
        doc.save("waiver.pdf");
      })
      .catch((err) => {
        console.log(err)
      });
      }

    setTimeout(() => {
      downloadBtn.innerText = "Download Waiver";
      downloadBtn.style.background = '#0d47f0';
    }, 5000)
  };
  
 




  private membershipUser = async (
    checkIn: Users.CheckIn,
    businessId: string
  ) => {
    // console.log('checkIn data...', checkIn);

    const query = await firestore
      .collection(`membership`)
      .where("mobile", "==", checkIn.mobile)
      .limit(1)
      .get();
    if (query.size > 0 ) {
      const data = query.docs[0].data();
      if (data && data.businessId === businessId) {
        const membership = data as Users.Membership;
        checkIn.membership = membership;
        this.setState({ membership });
      }
    }
  };

  private getGuidAndKiosk = async (
    checkIn: Users.CheckIn
  ): Promise<{ guid: string; kiosk: string }> => {
    // get business and site
    const businessQuery = await firestore
      .collection("businesses")
      .doc(checkIn.businessId)
      .get();
    const siteQuery = await firestore
      .collection("businesses")
      .doc(checkIn.businessId)
      .collection("sites")
      .doc(checkIn.siteId)
      .get();
    const business = businessQuery.data() as Businesses.Business;
    const site = siteQuery.data() as Businesses.Site;

    const guid = site.guid ? site.guid : business.guid;

    let kiosk = checkIn.language === "eng" ? site.kioskName : site.kioskNameEs;

    if (!kiosk) {
      kiosk = "";
    }

    return { guid, kiosk };
  };

  private getLoyaltyCycleText = async (
    checkIn: Users.CheckIn
  ): Promise<void> => {
    this.setState({ loyaltyCycleText: "..." });

    const { guid, kiosk } = await this.getGuidAndKiosk(checkIn);
    const data = {
      guid,
      kiosk,
      mobile: checkIn.mobile,
    };

    const text = await getLoyaltyCycle(data);
    if (text && typeof text.data === "string") {
      this.setState({ loyaltyCycleText: text.data });
    } else {
      this.setState({ loyaltyCycleText: "N/A" });
    }
  };

  private subscribeToUser = async (checkIn: Users.CheckIn) => {
    if (this.unsubscribeUser) {
      this.unsubscribeUser();
    }

    this.unsubscribeUser = await firestore
      .collection("users")
      .doc(checkIn.userId)
      .onSnapshot(
        { includeMetadataChanges: true },
        (snapshot) => {
          if (snapshot.exists) {
            const user = snapshot.data() as Users.User | Users.UserWithAccount;
            this.setState({ user });
          }
        },
        (error) => {
          throw error;
        }
      );
  };

  private subscribeToCoupons = async (checkIn: Users.CheckIn) => {
    const query = firestore.collection(`users/${checkIn.userId}/coupons`);
    const { businessId } = this.props;

    this.setState({ loadingCoupons: true });

    if (this.unsubscribeCoupons) {
      this.unsubscribeCoupons();
    }

    this.unsubscribeCoupons = await query.onSnapshot(
      { includeMetadataChanges: true },
      (snapshot) => {
        if (!snapshot.empty) {
          const coupons: Users.Coupon[] = [];

          snapshot.forEach((doc) => {
            const couponId = doc.id;
            const couponData = doc.data() as Users.Coupon;

            if (couponData) {
              const { redemption_flag } = couponData;

              if (
                redemption_flag === false &&
                businessId === couponData.businessId
              ) {
                coupons.push({ couponId, ...couponData });
              }
            }
          });

          this.setState({ coupons });
        }
      },
      (error) => {
        throw error;
      }
    );

    this.setState({ loadingCoupons: false });
  };

  private redeemCoupon = async ({
    currentTarget,
  }: React.MouseEvent<HTMLButtonElement>) => {
    const { checkIn } = this.props;
    const couponId = currentTarget.dataset.couponId;

    if (checkIn && couponId) {
      this.setState({ redeeming: true });

      await firestore
        .collection(`users/${checkIn.userId}/coupons`)
        .doc(couponId)
        .update({
          redemption_date: new Date(),
          redemption_flag: true,
        });

      this.setState({ redeeming: false });
    }
  };

  private selectMemshiStartDate = (showDatePicker,membership) =>{
    this.setState({ showDatePicker: !showDatePicker });
  }

  private handleDateChange = async (date) => {
    if (date !== null) {
      date.setHours(0, 0, 0, 0);
    }
    await this.setState({ memStartDate: date });
  };

  private setMembershipFeatureParamater = async (businessId: string) => {
    const businessQuery = await firestore
      .collection("businesses")
      .doc(businessId)
      .get();
    const data = businessQuery.data();

    if (data && data.proMembership !== undefined) {
      this.setState({ activateMembershipFeature: data.proMembership });
    } else {
      this.setState({ activateMembershipFeature: false });
    }
  };

  private noteUser = async (checkIn: Users.CheckIn) => {
    firestore
      .collection("notes")
      .where("businessId", "==", checkIn.businessId)
      .where("mobile", "==", checkIn.mobile)
      .onSnapshot((snapshot) => {
        let userNote = "";
        let tempTime = 0;
        if (!snapshot.empty) {
          snapshot.forEach((doc) => {
            const noteData = doc.data();
            if(tempTime < noteData.createdAt && noteData.note !== null){
              userNote = noteData.note;
              tempTime = noteData.createdAt;
            }

            // if(checkIn.checkInId === noteData.checkInId){
            //   userNote = noteData.note;
            // }

          });
        }
        this.setState({ userNote });
      });
  };

  private watchPicks = async (mobile: string, business: string, site: string) => {
    let query;
    if (business) {
      const businessQuery = await firestore
        .collection("businesses")
        .where("path", "==", business)
        .get();
      let businessDoc;
      if (!businessQuery.empty) {
        businessDoc = businessQuery.docs[0].data();
        // console.log(businessDoc);
        if (businessDoc.s3Id || businessDoc.urgId || !site || site === "-") {
          query = await firestore
            .collection("vehiclePicks")
            .where("mobile", "==", mobile)
            .where("businessId", "==", businessDoc.businessId)
            .get();
        } else if (site && site !== "-") {
          const siteQuery = await businessQuery.docs[0].ref
            .collection("sites")
            .where("path", "==", site)
            .get();
          const siteDoc = await siteQuery.docs[0].data();
          const siteId = siteQuery.docs[0].id;
          if (siteDoc.s3Id || siteDoc.urgId) {
            query = await firestore
              .collection("vehiclePicks")
              .where("mobile", "==", mobile)
              .where("siteId", "==", siteId)
              .get();
          } else {
            query = await firestore
              .collection("vehiclePicks")
              .where("mobile", "==", mobile)
              .get();
          }
        } else {
          query = await firestore
            .collection("vehiclePicks")
            .where("mobile", "==", mobile)
            .get();
        }
      }
    } else {
      query = await firestore
        .collection("vehiclePicks")
        .where("mobile", "==", mobile)
        .get();
    }

    const picks:VehiclePick[] = [];
    query.forEach((doc) => {
      const pick = doc.data() as VehiclePick;

      picks.push(pick);

    });

    this.setState({ picks });

  };

  private getJoinDate = (businessId, siteId, mobile) => {

    let query : any = firestore.collection("checkIns");
    if (businessId) {
      query = query.where("businessId", "==", businessId);
    }

    if (siteId && siteId !== "all") {
      query = query.where("siteId", "==", siteId);
    }
    if (mobile) {
      query = query.where("mobile", "==", mobile);
    }

    query = query.orderBy("timestamp", "asc").limit(1);
    query.get().then(
      (checkInsSnapshot) => {
        if(checkInsSnapshot.docs[0].data()){
          const joinDate = checkInsSnapshot.docs[0].data().timestamp;
          this.setState({ joinDate });
        }
      });

  }


  // private getTest = async () => {

  //   let query : any = firestore.collection("checkIns");
  //     query = query.where("businessId", "==", "gBHr1GdJSlpASgUvkoLW");


  //     const query1 = query.where("siteId", "==", "1YYyeZ1YXjGyc6Z6vwRt").get();
  //     const query2 = query.where("siteId", "==", "17VBJyeH2crmqQC2OSxx").get();

  //     const [capitalQuerySnapshot, italianQuerySnapshot]  = await Promise.all([query1,query2]);

  //     // query = query.where('siteId', 'array-contains', ["17VBJyeH2crmqQC2OSxx","1YYyeZ1YXjGyc6Z6vwRt"]);

  //     const capitalCitiesArray = capitalQuerySnapshot.docs;
  //     const italianCitiesArray = italianQuerySnapshot.docs;

  //     const citiesArray = capitalCitiesArray.concat(italianCitiesArray);

  //     citiesArray.forEach(element => {
  //       console.log(element);
  //     });

  // }


}

export default ActiveCheckIn;



// WEBPACK FOOTER //
// ./src/views/CheckIns/ActiveCheckIn/index.tsx